import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ⬇️ Tambahan
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Chromium dapat mengirim notifikasi ini ketika layout berubah beberapa kali
// dalam satu frame. Development overlay keliru menampilkannya sebagai error.
const ignoreResizeObserverNotification = (event) => {
  const message = event?.message || event?.reason?.message || '';
  if (
    message === 'ResizeObserver loop limit exceeded' ||
    message === 'ResizeObserver loop completed with undelivered notifications.'
  ) {
    event.stopImmediatePropagation?.();
    event.preventDefault?.();
  }
};

window.addEventListener('error', ignoreResizeObserverNotification, true);
window.addEventListener('unhandledrejection', ignoreResizeObserverNotification, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ⬇️ Aktifkan PWA
serviceWorkerRegistration.register(); //

reportWebVitals();
